import { types } from '../../../constants/ActionTypes'

const initialState = {
  planID: '',
  amount: 500,
}

const paypal = (state = initialState, action) => {
  switch (action.type) {
    case types.paypal.INIT: {
      return {
        planID: '',
        amount: 500
      }
    }
    case types.paypal.CHANGED_PLAN: {
      return {
        ...state,
        planID: action.planID
      }
    }
    case types.paypal.CHANGED_AMOUNT: {
      return {
        ...state,
        amount: action.amount
      }
    }
    default: {
      return state
    }
  }
}

export default paypal


// WEBPACK FOOTER //
// ./src/reducers/Common/PayPal/PayPal.js